<template>
  <form>
      <div class="row q-col-gutter-md">
        <div class="col col-xs-12 col-md-6 col-lg-6">
          <q-input
              v-model="ExchangeObj.name"
              :label="$t('exchanges.table_titles.name')"
              lazy-rules
              :error="ExchangeObj.errors.has('name')"
              :error-message="ExchangeObj.errors.get('name')"
              :rules="[ val => val && val.length > 0 || $t('exchanges.table_titles.name')+' is required!']"
          />
        </div> <!-- NAME -->
        <div class="col col-xs-12 col-md-6">
              <q-input
                  v-model="ExchangeObj.exchange_fee"
                  type="number"
                  input-class="text-center input-bold"
                  :label="$t('exchanges.table_titles.exchange_fee')"
                  lazy-rules
                  :error="ExchangeObj.errors.has('exchange_fee')"
                  :error-message="ExchangeObj.errors.get('exchange_fee')"
                  :rules="[ val => val && val >= 0 || $t('exchanges.table_titles.exchange_fee') + ' is required']"
                  color="input-color"
              />
          </div> <!-- EXCHANGE FEE -->
      </div>
    </form>
</template>

<script>

export default {
  name: 'Form',
  model: {
    prop: 'ExchangeObj'
  },
  props: {
    ExchangeObj: {
      type: Object,
      required: true
    }
  },
  computed: {},
  data() {
    return {

    }
  },
  methods: {
    submit() {
      this.$emit('submit')
    },
  },
  updated() {
    this.$emit('change', this.ExchangeObj)
  },
  components: {},
}
</script>

<style scoped>

</style>
